<div class="modal-body modal-scss">
  <form [formGroup]="addActionForm">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <p-checkbox formControlName="accuseDeReponse" binary="true"></p-checkbox>
          <span class="custom-h4-title ms-2">{{ 'action.wantReceiptConfirmation' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div [ngClass]="configApp?.mails?.hideStatutAction ? 'col-6' : 'col-4'">
        <div class="form-group">
          <h4 class="custom-h4-title">{{ 'action.action' | translate }}*</h4>
          <p-dropdown
            styleClass="w-100"
            [options]="actionTypes"
            [placeholder]="'action.selectAction' | translate"
            [showClear]="true"
            appendTo="body"
            formControlName="action">
            <ng-template let-item pTemplate="selectedItem"
              ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
            >
          </p-dropdown>
        </div>
      </div>
      @if (configApp?.mails?.hideStatutAction === false) {
        <div class="col-4">
          <div class="form-group">
            <h4 class="custom-h4-title">{{ 'action.status' | translate }}</h4>
            <p-dropdown
              styleClass="w-100"
              [options]="listOfStatus"
              [placeholder]="'action.selectStatus' | translate"
              [showClear]="true"
              appendTo="body"
              formControlName="statut">
              <ng-template let-item pTemplate="selectedItem"
                ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
              >
            </p-dropdown>
          </div>
        </div>
      }
      <div [ngClass]="configApp?.mails?.hideStatutAction ? 'col-6' : 'col-4'">
        <div class="p-fluid h-50">
          <h4 class="custom-h4-title">{{ 'action.dueDate' | translate }}</h4>
          <p-calendar
            [minDate]="today"
            [firstDayOfWeek]="1"
            appendTo="body"
            formControlName="echeance"
            [showIcon]="true"
            [iconDisplay]="'input'"
            dateFormat="dd/mm/yy"
            (onSelect)="checkSelectedDate($event)">
          </p-calendar>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <div class="form-group">
          <h4 class="custom-h4-title">{{ 'action.message' | translate }}</h4>
          <textarea
            rows="2"
            [placeholder]="'action.insertActionDescription' | translate"
            formControlName="message"
            class="super-compos-input-text form-control w-100"
            pInputTextarea></textarea>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      @if (!listOfChosenUsers.length && !listOfChosenServices.length && !listOfChosenGroups.length) {
        <app-icourrier-form-error [errorMessage]="'action.pleaseChooseARecipient' | translate"></app-icourrier-form-error>
      }
      <i-tabs [items]="recipientsTabs" (tabChange)="onActiveTabChange($event)"></i-tabs>

      <div style="max-height: 40dvh; overflow-y: auto" class="mt-2">
        @if (activeRecipientTab === 'users') {
          <app-icourrier-checkable-list
            [(items)]="listOfContacts"
            [itemLabel]="'label'"
            (onCheck)="onRecipientCheck($event)"></app-icourrier-checkable-list>
        } @else if (activeRecipientTab === 'groups') {
          <app-icourrier-checkable-list
            [(items)]="listOfGroups"
            [itemLabel]="'label'"
            (onCheck)="onRecipientCheck($event)"></app-icourrier-checkable-list>
        } @else if (activeRecipientTab === 'services') {
          <app-icourrier-checkable-list
            [(items)]="servicesFusionned"
            [itemLabel]="'description'"
            (onCheck)="onRecipientCheck($event)"></app-icourrier-checkable-list>
        }
      </div>

      <!-- <div class="col-6">
        <div class="form-group">
          <h4 class="custom-h4-title">{{ 'action.recipient' | translate }}*</h4>
          <p-multiSelect
            [options]="actionDestinataire | sort: 'label' : 'ASC'"
            [placeholder]="'action.selectRecipient' | translate"
            optionLabel="label"
            appendTo="body"
            styleClass="w-100"
            formControlName="ActionDestinataire"
            [required]="true"
            [virtualScroll]="true"
            virtualScrollItemSize="30">
          </p-multiSelect>
        </div>
      </div> -->
    </div>
    <div class="row">
      <div class="d-flex justify-content-end mt-3">
        <i-button (click)="closeActionModal()" [text]="'cancel' | translate" styleClass="red me-2"> </i-button>
        <i-button (click)="submit()" [text]="'add' | translate" styleClass="green"> </i-button>
      </div>
    </div>
  </form>
</div>
